import { Injectable } from "@angular/core";
import { fireAuth } from "src/app/shared-modules/initFirebase";
import { User, signInWithEmailAndPassword, sendEmailVerification, UserCredential, createUserWithEmailAndPassword, sendPasswordResetEmail, onAuthStateChanged } from "@firebase/auth";
import { AuthCredentials } from "src/app/models/user";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  public userId: string;
  private authStateKnown = false;
  private currentAuthUser: User | null = null;

  constructor() {
    onAuthStateChanged(fireAuth, (user) => {
      this.currentAuthUser = user;
      this.authStateKnown = true;
      this.userId = user ? user.uid : undefined;
    });
  }

  /** Resolves once Firebase auth state is known; stays in sync on login/logout. */
  waitForAuth(): Promise<User | null> {
    if (this.authStateKnown) {
      return Promise.resolve(this.currentAuthUser);
    }
    return new Promise((resolve) => {
      const unsubscribe = onAuthStateChanged(fireAuth, (user) => {
        unsubscribe();
        this.currentAuthUser = user;
        this.authStateKnown = true;
        this.userId = user ? user.uid : undefined;
        resolve(user);
      });
    });
  }

  getUser(): Promise<User> {
    return this.waitForAuth().then((user) => {
      if (user) {
        return user;
      }
      return Promise.reject(null);
    });
  }

  async loginUser(
    email: string,
    password: string
  ): Promise<AuthCredentials> {
    console.log("LOGINGIN");

    return  new Promise(async (resolve, reject) => {
      try {
        const firebaseCredential = await signInWithEmailAndPassword(fireAuth, email, password);

        resolve ( {
          uid : firebaseCredential.user.uid
        } )

      } catch (error) {
        reject(error)
      }
    })
  }
    

  async verifyMail(): Promise<void> {
    return sendEmailVerification(fireAuth.currentUser);
  }
  signupUser(
    email: string,
    password: string
  ): Promise<UserCredential> {
    return createUserWithEmailAndPassword(fireAuth, email, password);
  }

  resetPassword(email: string): Promise<void> {
    console.log("send reset", email);
    return sendPasswordResetEmail(fireAuth, email)
      .then((f) => {
        console.log("successfully send pw reset", f);
      })
      .catch((e) => {
        console.error("fail send pw reset", e);
      });
  }

  logoutUser(): Promise<void> {
    return fireAuth.signOut();
  }

  deleteUser(): Promise<void> {
    return fireAuth.currentUser.delete();
  }
}
